export default [
    {
        name: 'Pagamentos',
        url: '/gescon/financeiro/pagamentos',
        icon: 'fa fa-dollar',
        regras: 'GESCON-UFI-PAG-00'
    },
    {
        name: 'Serviços',
        url: '/gescon/financeiro/servicos',
        icon: 'fa fa-truck',
        regras: 'GESCON-UFI-APROV-00', 
        badge: {
            variant: 'primary',
            text: 'FINANCEIRO'
        }
    }
]
